<template>
  <div class="common-input">
    <el-input
      size="medium"
      :placeholder="placeholder"
      suffix-icon="el-icon-search"
      v-model="inputContent"
    ></el-input>
  </div>
</template>

<script>
export default {
  name: 'CommonInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请搜索',
    },
  },
  data() {
    return {
      inputContent: '',
    }
  },
  created() {
    this.inputContent = this.value
  },
  watch: {
    inputContent(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style lang='scss'>
.common-input {
  width: 220px;
  .el-input {
    .el-input__inner {
      border: none;
      border-bottom: 1px solid #aaaaaa;
      border-radius: 0;
    }
  }
}
</style>